export default {
    routeChange: false,
    header_title: null,
}
